import Log from './log';

export default class Calendar {
  constructor() {
    this.calendar = $('.js-calendar');
    this.activeDate = this.calendar.data('active-date');
    this.initialMonth = this.calendar.data('initial-month');
    this.currentCalendar = $('.js-calendar-month.is_visible');
    this.prevButton = $('.js-calendar-prev');
    this.nextButton = $('.js-calendar-next');

    this.calendarMonthSelector = '.js-calendar-month';

    if (this.calendar.length) {
      this.slider();
      // Update active date class
      $(`.calendar-item--${this.activeDate}`).addClass('calendar-item--current');
      // Set initial calendar
      $(`.js-calendar-month--${this.initialMonth}`).addClass('is_visible');

      // Log which dates are being selected
      $('.calendar-item-content').on('click', (event) => {
        Log.track('Date Picker', 'selected', $(event.target).attr('href'));
      });
    }
  }

  slider() {
    this.prevButton.on('click', (event) => {
      const thisMonth = $(event.target).closest(this.calendarMonthSelector);
      const prevMonth = thisMonth.prev(this.calendarMonthSelector);
      thisMonth.removeClass('is_visible');
      prevMonth.addClass('is_visible');
      Log.track('Date Picker', 'navigate', 'Previous Month');
    });
    this.nextButton.on('click', (event) => {
      const thisMonth = $(event.target).closest(this.calendarMonthSelector);
      const nextMonth = thisMonth.next(this.calendarMonthSelector);
      thisMonth.removeClass('is_visible');
      nextMonth.addClass('is_visible');
      Log.track('Date Picker', 'navigate', 'Next Month');
    });
  }
}
